import React from "react";

export function Skeleton({ className = "" }) {
  return <div className={`rl-skeleton rounded-lg ${className}`} />;
}

export function CardSkeletonList({ count = 4 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rl-card p-4">
          <Skeleton className="h-5 w-2/3 mb-3" />
          <Skeleton className="h-4 w-1/2 mb-2" />
          <Skeleton className="h-10 w-full" />
        </div>
      ))}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 rl-fade-up" data-testid="empty-state">
      {Icon && (
        <div className="w-16 h-16 rounded-2xl rl-card flex items-center justify-center mb-4">
          <Icon className="w-8 h-8 text-blue-600" />
        </div>
      )}
      <h3 className="font-display text-lg font-bold text-slate-900">{title}</h3>
      {subtitle && <p className="text-sm text-slate-500 mt-1 max-w-xs">{subtitle}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
